/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import classNames from 'classnames';
import useThemeStore from '$/store/useThemeStore';
import roboneoLogo from '@/assets/roboneo-logo.png';
import styles from './index.module.scss';

interface ProjectCoverProps extends Pick<React.ImgHTMLAttributes<HTMLImageElement>, 'sizes' | 'width' | 'height'> {
  src?: string;
  /** 仅用于真实封面，避免宿主 hover 缩放影响兜底 Logo。 */
  imageClassName?: string;
}

/** 每个封面地址独立维护失败状态，空封面和加载失败共用主题 Logo。 */
function ProjectCoverImage({
  src, imageClassName, width, height, sizes,
}: ProjectCoverProps) {
  const theme = useThemeStore((state) => state.theme);
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <img
        className={styles.logo}
        crossOrigin="anonymous"
        src={roboneoLogo.src}
        alt=""
        loading="eager"
        draggable={false}
        style={{ filter: theme === 'light' ? 'brightness(0)' : 'none' }}
      />
    );
  }

  return (
    <img
      width={width}
      height={height}
      sizes={sizes}
      className={classNames(styles.cover, imageClassName)}
      crossOrigin="anonymous"
      src={src}
      alt=""
      draggable={false}
      onError={() => setFailed(true)}
    />
  );
}

/** 封面 URL 更新后重新加载，避免沿用上一个 URL 的失败状态。 */
export default function ProjectCover({
  src = '', imageClassName, width, height, sizes,
}: ProjectCoverProps) {
  const coverSrc = src.trim();
  return (
    <ProjectCoverImage
      key={coverSrc}
      src={coverSrc}
      imageClassName={imageClassName}
      width={width}
      height={height}
      sizes={sizes}
    />
  );
}
